// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const handcartFuture = defineModel({
  id: "handcart-future",
  batchId: "future",
  name: "Handcart",
  tags: ["scenery","handcart","low-poly","age-of-mcp","future"],
  summary: "A two-wheeled handcart — moves goods short distances by hand.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.TorusGeometry(0.16, 0.028, 5, 12), color: "#3a352f", position: [0, 0.16, 0.2], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.06, 6), color: "#5a4a36", position: [0, 0.16, 0.2], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, 0.2] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, 0.2], rotation: [0, 0, 0.785398] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, 0.2], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, 0.2], rotation: [0, 0, 2.356194] },
      { geometry: new THREE.TorusGeometry(0.16, 0.028, 5, 12), color: "#3a352f", position: [0, 0.16, -0.2], rotation: [0, 1.570796, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.06, 6), color: "#5a4a36", position: [0, 0.16, -0.2], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, -0.2] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, -0.2], rotation: [0, 0, 0.785398] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, -0.2], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.BoxGeometry(0.018, 0.272, 0.018), color: "#5a4a36", position: [0, 0.16, -0.2], rotation: [0, 0, 2.356194] },
      { geometry: new THREE.BoxGeometry(0.46, 0.05, 0.42), color: "#9a6a38", position: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.46, 0.07, 0.03), color: "#6f4a26", position: [0, 0.25, 0.2] },
      { geometry: new THREE.BoxGeometry(0.46, 0.07, 0.03), color: "#6f4a26", position: [0, 0.25, -0.2] },
      { geometry: new THREE.BoxGeometry(0.03, 0.07, 0.42), color: "#6f4a26", position: [-0.23, 0.25, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.03), color: "#9a6a38", position: [0.46, 0.28, 0.13], rotation: [0, 0, 0.18] },
      { geometry: new THREE.BoxGeometry(0.5, 0.03, 0.03), color: "#9a6a38", position: [0.46, 0.28, -0.13], rotation: [0, 0, 0.18] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.3, 6), color: "#6f4a26", position: [0.69, 0.33, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.18, 0.18), color: "#a9763f", position: [-0.08, 0.33, 0.08] },
      { geometry: new THREE.SphereGeometry(0.1, 6, 5), color: "#c7b27a", position: [0.06, 0.31, -0.1], scale: [1, 0.8, 1.1] },
    ],
  animations: [],
});
